<!-- 创建时间2023/06/26 09:19:46 -->
<!-- 创建人：Zhao bing bing -->
<!-- 组件描述：上传创建 -->
<template>
  <div class="yxtbiz-kng-operator__multi">
    <yxt-alert 
      v-if="module === 'ulcd'"
      class="mb24"
      :title="$t('pc_biz_lbl_couseuploadtip'/**课程发布成功后，上传的文件会自动生成课件，可以在课件管理中查看，默认隐藏，学员不可见 */)"
      type="regular"
      show-icon
      :closable="false">
    </yxt-alert>
    <yxt-button @click="continueUpload" :disabled="infoList.length >= maxLength">{{ $t('pc_comp_upload_continue'/** 继续上传 */) }}</yxt-button>
    <yxt-button v-if="infoList.length > 1" @click="multiEdit">{{ $t('pc_kng_upload_lbl_batch_change'/**批量修改 */) }}</yxt-button>
    <!-- table组件的expand会多次渲染，弃用 -->
    <div class="yxtbiz-flex-center yxtbiz-kng-operator__multi-th pv14 ph24 mt16" v-if="infoList.length">
      <yxt-checkbox :value="checkAll" :indeterminate="isIndeterminate" @change="handleCheckAll(checkAll)"></yxt-checkbox>
      <div class="yxtbiz-flex-1 ml12 over-hidden">{{ $t('pc_biz_kng_lbl_courseware_name'/** 课件名称*/) }}</div>
      <div class="yxtbiz-w240 ml12">{{ $t('pc_biz_kng_lbl_status'/**状态 */) }}</div>
      <div class="yxtbiz-w110 ml12">{{ $t('pc_biz_kng_lbl_operate'/**操作 */) }}</div>
    </div>
    <div v-for="item in infoList" :key="item._uuid">
      <div class="yxtbiz-flex-center yxtbiz-kng-operator__multi-tr pv14 ph24">
          <yxt-checkbox :value="isSelected(item)" @change="change(item)" :disabled="item._status === 1"></yxt-checkbox>
          <div class="yxtbiz-flex-1 ml12 over-hidden">
            <div
              class="yxtbiz-flex-center yxtbiz-kng-operator__kngName"
              @click="clickRow(item, $event)"
            >
              <yxt-svg
                :remote-url="kngFileTypeIconUrl"
                width="20px"
                height="20px"
                :icon-class="getTypeIcon(item)"
              />
              <yxt-input
                v-if="current === item"
                class="yxtbiz-kng-operator__table-input"
                v-model="item.title"
                maxlength="200"
                autofocus
                show-word-limit
                @blur="current = undefined"
              ></yxt-input>
              <span
                v-else
                class="yxtbiz-kng-operator__table-title ellipsis-1 yxtbiz-flex-1"
              >
                {{ item.title }}
              </span>
            </div>
          </div>
          <div class="yxtbiz-w240 ml12">
            <yxt-progress
              class="yxtbiz-w100"
              v-if="item._status === 0"
              :percentage="item._percentage"
            ></yxt-progress>
            <yxt-tag
              v-else-if="item._status === 1"
              is-status-tag
              type="danger"
              >
              <yxt-tooltip :content="item._error" placement="top">
                <div class="yxtbiz-w200 over-hidden ellipsis">{{ item._error }}</div>
              </yxt-tooltip>
            </yxt-tag>
            <yxt-tag v-else is-status-tag type="success">{{ $t('pc_kng_upload_lbl_already_success_other'/**上传成功 */) }}</yxt-tag>
          </div>
          <div class="yxtbiz-w110 ml12">
            <template v-if="item._status !== 1">
              <yxt-button type="text" @click="expand(item)">{{ item._expand ? $t('pc_kng_common_btn_pack_up'/**收起 */) : $t('pc_kng_common_btn_pack_open'/**展开 */) }}</yxt-button>
              <yxt-divider direction="vertical"></yxt-divider>
            </template>
            <yxt-button type="text" @click="del(item)">{{ $t('pc_biz_kng_lbl_delete'/**删除 */) }}</yxt-button>
          </div>
        </div>  
        <div class="pv24 ph8 yxtbiz-kng-operator__multi-tr"  :key="'2_' + item._uuid" v-show="item._expand">
          <kng-form class="yxtbiz-w640" :ref="`forms_${item._uuid}`" :info="item"/>
        </div>
    </div>

    <!-- 批量修改 -->
    <kng-edit-multi-drawer ref="editMulti" @confirm="confirm"/>
  </div>
</template>

<script>
import {
  getKngFileTypeIcon,
  kngFileTypeIconUrl
} from 'yxt-biz-pc/packages/select-kng/src/utils';
import KngForm from './widget/kng-form.vue';
import KngEditMultiDrawer from './kng-edit-multi-drawer.vue';
export default {
  name: 'kng-form-multi',
  components: {
    KngForm,
    KngEditMultiDrawer
  },
  inject: ['getModule', 'getMaxLength'],
  props: {
    infoList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      kngFileTypeIconUrl,
      current: undefined,
      selected: [],
      isIndeterminate: false,
      checkAll: false
    };
  },
  computed: {
    module() {
      return this.getModule();
    },
    maxLength() {
      return this.getMaxLength();
    }
  },
  methods: {
    getTypeIcon(info) {
      const { fileType, type } = info;
      return getKngFileTypeIcon(fileType, type);
    },
    clickRow(row, e) {
      this.current = row;
      this.$nextTick(() => {
        document
          .querySelector('.yxtbiz-kng-operator__table-input')
          .querySelector('input')
          .focus();
      });
    },
    del(row) {
      row._abort && row._abort();
      const index = this.infoList.findIndex(item => item === row);
      index > -1 && this.infoList.splice(index, 1);
    },
    edit(row) {
      this.$refs.kngEdit.edit(row)
        .then(info => {
          Object.assign(row, info);
        });
    },
    expand(row) {
      this.$set(row, '_expand', !row._expand);
    },
    handleSelectionChange(val) {
      this.selected = val;
    },
    continueUpload() {
      this.$emit('continueUpload');
    },
    multiEdit() {
      if (this.selected.length === 0) return this.$message.warning(this.$t('pc_biz_lbl_selectkngfirst'/** 请先选择课件！ */));
      const selectedForms = [];
      for (let i = 0; i < this.selected.length; i++) {
        selectedForms.push(this.$refs[`forms_${this.selected[i]._uuid}`][0]);
      }
      this.$refs.editMulti.init(this.selected, selectedForms);
    },
    isSelected(row) {
      return this.selected.some(item => item._uuid === row._uuid);
    },
    handleCheckAll(val) {
      this.checkAll = !val;
      this.isIndeterminate = false;
      if (this.checkAll) {
        this.selected = this.infoList;
      } else {
        this.selected = [];
      }
    },
    confirm() {
      this.checkAll = false;
      this.isIndeterminate = false;
      this.selected = [];
    },
    change(row) {
      if (this.isSelected(row)) {
        const index = this.selected.findIndex(item => item._uuid === row._uuid);
        index > -1 && this.selected.splice(index, 1);
      } else {
        this.selected.push(row);
      }
      this.checkAll = this.selected.length === this.infoList.length;
      this.isIndeterminate = this.selected.length !== this.infoList.length && this.selected.length > 0;
    },
    validate() {
      return new Promise(async(resolve, reject) => {
        let isPass = true;
        for (let i = 0; i < this.infoList.length; i++) {
          try {
            const comp = this.$refs[`forms_${this.infoList[i]._uuid}`][0];
            await comp.validate();
          } catch (e) {
            isPass = false;
            this.$set(this.infoList[i], '_expand', true);
          }
        }
        if (isPass) {
          resolve();
        } else {
          reject(new Error('fail'));
        }
      });
    }
  }
};
</script>